
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a-life-lived",
      function () {
        return require("private-next-pages/a-life-lived/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a-life-lived"])
      });
    }
  